export const propMapperArray = {
  Authentication: [],
  TopNav: [
    { key: "username", identifier: "auth.credentials.username" },
    { key: "credentials", identifier: "auth.credentials" },
  ],
  Transactions: [
    {
      key: "transactionParams",
      identifier: "transactionParams.transactionParams",
    },
    {
      key: "transactionTable",
      identifier: "transactionTable.transactionTable",
    },
    {
      key: "previousTable",
      identifier: "transactionTable.previousTable",
    },
    {
      key: "contToken",
      identifier: "transactionTable.contToken",
    },
    {
      key: "dailyAnalytics",
      identifier: "analyticsInfo.daily",
    },
    {
      key: "weeklyAnalytics",
      identifier: "analyticsInfo.weekly",
    },
    {
      key: "monthlyAnalytics",
      identifier: "analyticsInfo.monthly",
    },
  ],
};

export const dispatchMapperArray = {
  Authentication: [
    {
      key: "signInSuccess",
      identifier: "signIn",
    },
    {
      key: "signOut",
      identifier: "signOut",
    },
  ],
  TopNav: [
    {
      key: "signOut",
      identifier: "signOut",
    },
  ],
  Transactions: [
    { key: "updateTransParams", identifier: "updateTransParams" },
    { key: "transactionTableFetch", identifier: "transactionTableFetch" },
    {
      key: "transactionTablePreviousFetch",
      identifier: "transactionTablePreviousFetch",
    },
    {
      key: "transactionTableContinuationToken",
      identifier: "transactionTableContinuationToken",
    },
    {
      key: "dailyAnalyticsFetch",
      identifier: "dailyAnalyticsFetch",
    },
    {
      key: "weeklyAnalyticsFetch",
      identifier: "weeklyAnalyticsFetch",
    },
    {
      key: "monthlyAnalyticsFetch",
      identifier: "monthlyAnalyticsFetch",
    },
  ],
};

export const routes = {
  base: "/",
  signin: "/signin",
  users: "/users",
};

export const tokenIdf = "challanTokens";
